import * as React from "react";
import type { ContractFamilyProjectionReadinessResponse } from "@/types/contract-family";

interface Props {
  readiness: ContractFamilyProjectionReadinessResponse;
}

export const ProjectionReadinessBanner: React.FC<Props> = ({ readiness }) => (
  <div
    className="mb-4 flex flex-wrap items-center gap-x-4 gap-y-1 rounded-md border border-orange-200 bg-orange-50 px-4 py-2 text-sm text-gray-800"
    aria-live="polite"
  >
    <span>
      <strong>{readiness.ready_count}</strong> projected rows ready
    </span>
    {readiness.unready_count > 0 && (
      <span>
        <strong>{readiness.unready_count}</strong> unavailable until summaries are generated or refreshed
      </span>
    )}
    {readiness.excluded_count > 0 && (
      <span>
        <strong>{readiness.excluded_count}</strong> hidden by current document access
      </span>
    )}
  </div>
);
